module.exports = __webpack_public_path__ + "img/home_video_mobile.549569bf.jpg";